module.exports = __webpack_public_path__ + "static/memorial_card_img4-eb1858b3d8e76848e3cb2d527b09569f.jpg";